import React from 'react'
import { Button, Badge } from 'antd'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import config from '../../config'
import { userLogout } from '../../services'
import './style.less'

function UserPanel(props: any)  {
  const showMessage = typeof props.message === 'undefined' ? true : props.message
  let history = useHistory()
  let userInfo = useSelector((state: any) => state.user)

  const jumpMessage = () => {
    history.push('/sider/message')
  }

  const logout = () => {
    userLogout({}).then(_=> {
      let env = process.env.REACT_APP_BM_ENV || 'development'
      window.location.href = `${config[env].loginDomain}?redirect=${window.location.origin}&app_name=cpc_bm&tplid=3`
    })
  }

  return (
    <div className="user-panel">
      {showMessage && (
        <Badge count={userInfo.unread_message_num}>
          <span className="user-item iconfont BM_icicon_news" onClick={e => jumpMessage()}/>
        </Badge>
      )}
      <span className="user-item">{userInfo.name}</span>
      <span className="user-item">ID: {userInfo.adv_user_id}</span>
      <Button type="link" onClick={e => logout()}>退出</Button>
    </div>
  )
}

export default UserPanel



// WEBPACK FOOTER //
// ./src/components/UserPanel/UserPanel.tsx